module.exports = __webpack_public_path__ + "img/Autocolant TSH_150mm x 180mm-01.708ea4cf.jpg";